import { ValidationType } from '../utils/validators';

import Field, { FieldDataType } from './Field';
import { Section } from './index';
import { SNOW_REMOVAL } from '../constants';

/**
 * Class to model Snow Removal Section data returned by API
 */
export default class SnowRemovalSection extends Section {
  constructor(args) {
    super(args);

    this.setIndexedFieldTypes([
      new Field({
        fieldName: SNOW_REMOVAL.FIELD_NAME.CUSTOM_AREA_IS_ENABLED,
        dataType: FieldDataType.boolean,
        enteredValue: true,
        validation: ValidationType.BooleanValidator,
      }),
      new Field({
        fieldName: SNOW_REMOVAL.FIELD_NAME.CUSTOM_AREA_RESPONSIBILITY,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: ValidationType.AlphaOnlyValidator,
      }),
      new Field({
        fieldName: SNOW_REMOVAL.FIELD_NAME.CUSTOM_AREA_DESCRIPTION,
        enteredValue: '',
        dataType: FieldDataType.string,
        validation: null,
      }),
    ]);
  }
}
